export default {
  direction: 0,
  start: null,
  end: null,
};
